module.exports = __webpack_public_path__ + "img/PPT.f2cafa8c.png";